import React, { useState } from 'react';

const STORAGE_KEY = 'tiskstrihu_promo_dismissed';

const PromoBanner: React.FC = () => {
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem(STORAGE_KEY) === '1'; } catch { return false; }
  });

  if (dismissed) return null;

  const close = () => {
    try { localStorage.setItem(STORAGE_KEY, '1'); } catch {}
    setDismissed(true);
  };

  return (
    <div className="pd-promo" role="region" aria-label="Akční nabídka">
      <span className="pd-promo__icon" aria-hidden="true">✶</span>
      <span className="pd-promo__text">
        <strong>Doprava zdarma</strong> nad 1 500 Kč &nbsp;•&nbsp; <strong>Elektronické střihy</strong> ihned po platbě
      </span>
      <button className="pd-promo__close" onClick={close} aria-label="Zavřít upozornění">×</button>
    </div>
  );
};

export default PromoBanner;
